module.exports = __webpack_public_path__ + "static/media/winners_s.6df857b2.webp";